import client from '../axios'
import getCSRFTokenApi from './getCsrfTokenApi';

const resetPasswordApi= async (data) => {
    await getCSRFTokenApi();
    return client.post('api/reset-password', data);
  };
  
export default resetPasswordApi;